import React, {Fragment} from "react";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import {searchGroupProviders, searchProviders} from "../../../../api/pro-guest-functions";
import {TableLoadingRow} from "../../../ui/table/TableLoadingRow";
import {makeStyles} from "@material-ui/core/styles/index";
import {withLazyDynamicTable} from "../../../ui/hoc/LazyDynamicTable";
import {TableEmptyRow} from "../../../ui/table/TableEmptyRow";

const useStyles = makeStyles(theme => ({
    search: {
        [theme.breakpoints.down('sm')]: {
            width: '100%'
        },
        [theme.breakpoints.up('md')]: {
            width: '40%'
        }
    }
}));


const _Providers = ({
                        organizationId,
                        folderId,
                        groupId,
                        headerRender,
                        rowRender,
                        data: providers,
                        loading
                    }: any) => {

    return (
        <Fragment>
            <TableHead>
                {headerRender()}
            </TableHead>
            <TableBody>
                {
                    loading ? <TableLoadingRow/> :
                        providers.length === 0 ?
                            <TableEmptyRow messageKey='ProGuest.Providers.Table.EmptyMessage'/> :
                            providers.map(rowRender)
                }
            </TableBody>
        </Fragment>
    );
};

export const Providers = (properties: any) => {
    const {organizationId, folderId, groupId, isFolderProviderSearch} = properties;
    const query = (lazyLoadingArgs: any) => isFolderProviderSearch ?
        (groupId ? searchProviders({...lazyLoadingArgs, organizationId, folderId, groupId})
            : searchProviders({...lazyLoadingArgs, organizationId, folderId}))
        : searchGroupProviders({...lazyLoadingArgs, organizationId, folderId, groupId});
    return withLazyDynamicTable(_Providers, query, ['organizationId', 'folderId', 'groupId'])(properties);
};
